import { useContext } from 'react';

import { NotificationContext } from 'contexts/Notification';

const useNotifications = () => {
  return useContext(NotificationContext);
};

export default useNotifications;
